export enum ETimerAppearanceSeparator {
    none = 'none',
    colon = 'colon',
    line = 'line',
}
